module.exports = __webpack_public_path__ + "img/depmap_svg_V119.ab5186c1.svg";